import { useRef } from 'react'
import { useField } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { UseUploadImageType } from './uploadImageType'
import { composeValidators, uploadRequired } from '../../utilities/validate'
import useTranslate from '../../i18n/useTranslate'

const useUploadImage = (props: UseUploadImageType) => {
    const translate = useTranslate()
    const refElementUpload = useRef<any>()
    const refElementHelperText = useRef<any>()

    const { required, validates = [], name } = props

    const handleClickUpload = () => {
        refElementUpload.current.click()
    }

    const handleChangeUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(event)
    }

    const mergeValidate = () => {
        let validate: Array<FieldValidator<any>> = []
        if (typeof required === 'boolean' && required) {
            validate = [uploadRequired(`${translate.get('UM.UPLOAD.REQUIRED')}`), ...validates]
        }

        return validate
    }

    const field = useField<string>(name, {
        validate: composeValidators(...mergeValidate()),
    })

    return {
        refElementUpload,
        refElementHelperText,
        onClickUpload: handleClickUpload,
        onChangeUpload: handleChangeUpload,
        field,
    }
}

export default useUploadImage
